import { useDialogStore, type DialogStoreState } from './store';

export { Dialog } from './Dialog';
export type { DialogRootProps, DialogContentProps } from './types';

export const showModal: DialogStoreState['showModal'] = (props) => {
  return useDialogStore.getState().showModal(props);
};
